<script lang="ts">
	import { sha256Hex } from '$lib/appstate.svelte';
	const { verb, category } = $props<{ verb: string; category: string }>();

	let message = $state('');

	async function submit() {
		const msg = message.trim();
		if (!msg) return;

		const body = JSON.stringify({ message: msg, verb, category });
		const payloadHash = await sha256Hex(body);

		fetch('/api/message', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', 'X-Amz-Content-Sha256': payloadHash },
			body: body
		});

		message = '';
	}
</script>

<div class="flex w-full flex-col gap-4">
	<textarea
		class="w-full rounded-xl border border-gray-300 p-3 text-base leading-relaxed"
		bind:value={message}
		placeholder="Enter your feedback. If you'd like a response, include your email address"
		rows={4}
	></textarea>

	<button class="rounded-xl border border-black px-4 py-2 text-base" onclick={submit}>
		Send Feedback
	</button>
</div>
